import { render, staticRenderFns } from "./CompleteComponent.vue?vue&type=template&id=640afc44&scoped=true&"
import script from "./CompleteComponent.vue?vue&type=script&lang=js&"
export * from "./CompleteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640afc44",
  null
  
)

export default component.exports